import queryString from "query-string";
import type { ParsedUrlQuery } from "querystring";

export function calculateUrl(options: {
  href: string | undefined;
  query: ParsedUrlQuery;
}): string {
  function calculateQs() {
    const query = queryString.stringify(options.query);

    if (!query) return "";

    if (options.href && options.href.indexOf("?") > -1) {
      return `&${query}`;
    } else {
      return `?${query}`;
    }
  }

  return `${options.href}${calculateQs()}`;
}
